(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brix-app-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brix-image-lightbox')) {
    class BrixImageLightbox extends HTMLElement {
      constructor() {
        super();
        this.scale = 1.0;
        this.minScale = 1.0;
        this.maxScale = 3.5;
        this.scaleStep = 0.25;
        this.posX = 0;
        this.posY = 0;
        this.isDragging = false;
        this.startX = 0;
        this.startY = 0;
        this.touchDistance = 0;
        this.touchScaleStart = 1.0;
        this.isPinching = false;
        this.openedBy = null;
        this.isOpen = false;
        this.lastTap = 0;
        this.closeTimeout = null;
        this.focusTimeout = null;
        this.currentSrc = '';
        this.loadCount = 0;

        this.backdrop = this.querySelector('.brix-lightbox__backdrop');
        this.stage = this.querySelector('.brix-lightbox__stage');
        this.viewport = this.querySelector('.brix-lightbox__viewport');
        this.canvas = this.querySelector('.brix-lightbox__canvas');
        this.image = this.querySelector('.brix-lightbox__image');
        this.closeBtn = this.querySelector('.brix-lightbox__close');

        this.boundOnKeydown = this.onKeydown.bind(this);
        this.boundOnPointerMove = this.onPointerMove.bind(this);
        this.boundOnPointerUp = this.onPointerUp.bind(this);
      }

      connectedCallback() {
        if (!this.moved) {
          this.moved = true;
          document.body.appendChild(this);
        }

        this.initEvents();
      }

      initEvents() {
        if (this.eventsInitialized) return;
        this.eventsInitialized = true;

        if (!this.closeBtn) {
          this.closeBtn = this.querySelector('.brix-lightbox__close');
        }
        if (!this.backdrop) {
          this.backdrop = this.querySelector('.brix-lightbox__backdrop');
        }

        if (this.backdrop) {
          this.backdrop.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        }
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.close();
          });
        }

        this.addEventListener('click', (e) => {
          const closeEl = e.target.closest('.brix-lightbox__close');
          if (closeEl) {
            e.preventDefault();
            e.stopPropagation();
            this.close();
            return;
          }
          if (
            e.target === this.stage ||
            e.target === this.backdrop ||
            e.target === this.viewport ||
            (e.target.classList && e.target.classList.contains('brix-lightbox__dialog'))
          ) {
            e.preventDefault();
            this.close();
          }
        });

        if (this.image) {
          this.image.addEventListener('mousedown', (e) => {
            if (e.button !== 0 || this.scale <= 1) return;
            e.preventDefault();
            this.isDragging = true;
            this.startX = e.clientX - this.posX;
            this.startY = e.clientY - this.posY;
            this.canvas.classList.add('is-panning', 'is-grabbing');
          });

          this.image.addEventListener('dblclick', (e) => {
            e.preventDefault();
            if (this.scale > 1.0) {
              this.setZoom(1.0);
            } else {
              this.setZoom(2.0);
            }
          });
        }

        window.addEventListener('mousemove', this.boundOnPointerMove);
        window.addEventListener('mouseup', this.boundOnPointerUp);

        if (this.stage) {
          this.stage.addEventListener('wheel', (e) => {
            if (!this.isOpen) return;
            e.preventDefault();
            const delta = e.deltaY < 0 ? 0.25 : -0.25;
            this.setZoom(this.scale + delta, false);
          }, { passive: false });

          this.stage.addEventListener('touchstart', (e) => {
            if (!this.isOpen) return;
            if (e.touches.length === 2) {
              this.isPinching = true;
              this.isDragging = false;
              this.touchDistance = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
              );
              this.touchScaleStart = this.scale;
            } else if (e.touches.length === 1 && this.scale > 1) {
              this.isDragging = true;
              this.startX = e.touches[0].clientX - this.posX;
              this.startY = e.touches[0].clientY - this.posY;
              this.canvas.classList.add('is-panning');
            }
          }, { passive: true });

          this.stage.addEventListener('touchmove', (e) => {
            if (!this.isOpen) return;
            if (this.isPinching && e.touches.length === 2) {
              e.preventDefault();
              const dist = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
              );
              if (this.touchDistance > 0) {
                const factor = dist / this.touchDistance;
                this.setZoom(this.touchScaleStart * factor, false);
              }
            } else if (this.isDragging && e.touches.length === 1) {
              e.preventDefault();
              this.posX = e.touches[0].clientX - this.startX;
              this.posY = e.touches[0].clientY - this.startY;
              this.clampPositions();
              this.canvas.style.transform = `translate(${Math.round(this.posX)}px, ${Math.round(this.posY)}px) scale(${this.scale})`;
            }
          }, { passive: false });

          this.stage.addEventListener('touchend', (e) => {
            if (this.isPinching && e.touches.length < 2) {
              this.isPinching = false;
            }
            if (this.isDragging && e.touches.length === 0) {
              this.isDragging = false;
              this.canvas.classList.remove('is-panning');
            }

            if (e.changedTouches.length === 1 && !this.isPinching) {
              const now = Date.now();
              if (now - this.lastTap < 320 && now - this.lastTap > 0) {
                e.preventDefault();
                if (this.scale > 1.0) {
                  this.setZoom(1.0);
                } else {
                  this.setZoom(2.0);
                }
              }
              this.lastTap = now;
            }
          });
        }

        window.addEventListener('resize', () => {
          if (this.isOpen && this.scale > 1) {
            this.clampPositions();
            this.updateTransform(true);
          }
        });

        document.addEventListener('click', (e) => {
          const closeBtn = e.target.closest('.brix-lightbox__close');
          if (closeBtn && this.isOpen) {
            e.preventDefault();
            e.stopPropagation();
            this.close();
            return;
          }

          const trigger = e.target.closest('.brix-showcase__media-col .brix-showcase__image-trigger');
          if (trigger) {
            const section = trigger.closest('.shopify-section');
            const targetSectionId = this.dataset.sectionId || this.getAttribute('data-section-id');
            if (section && targetSectionId && section.id && !section.id.includes(targetSectionId)) {
              return;
            }
            e.preventDefault();
            const zoomSrc = trigger.getAttribute('data-zoom-src') || trigger.querySelector('img')?.currentSrc || trigger.querySelector('img')?.src;
            const alt = trigger.getAttribute('data-zoom-alt') || trigger.querySelector('img')?.alt || '';
            if (zoomSrc) {
              this.open({ src: zoomSrc, alt, opener: trigger });
            }
          }
        });
      }

      onPointerMove(e) {
        if (!this.isDragging || this.scale <= 1) return;
        e.preventDefault();
        this.posX = e.clientX - this.startX;
        this.posY = e.clientY - this.startY;
        this.clampPositions();
        this.canvas.style.transform = `translate(${Math.round(this.posX)}px, ${Math.round(this.posY)}px) scale(${this.scale})`;
      }

      onPointerUp() {
        if (this.isDragging) {
          this.isDragging = false;
          this.canvas.classList.remove('is-panning', 'is-grabbing');
        }
      }

      onKeydown(e) {
        if (!this.isOpen) return;

        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          this.close();
          return;
        }

        // Ctrl + and Ctrl - for zooming (also Cmd on macOS)
        if (e.ctrlKey || e.metaKey) {
          const isPlus = e.key === '+' || e.key === '=' || e.code === 'Equal' || e.code === 'NumpadAdd';
          const isMinus = e.key === '-' || e.key === '_' || e.code === 'Minus' || e.code === 'NumpadSubtract';
          const isZero = e.key === '0' || e.code === 'Digit0' || e.code === 'Numpad0';

          if (isPlus) {
            e.preventDefault();
            this.setZoom(this.scale + this.scaleStep);
            return;
          }

          if (isMinus) {
            e.preventDefault();
            this.setZoom(this.scale - this.scaleStep);
            return;
          }

          if (isZero) {
            e.preventDefault();
            this.setZoom(1.0);
            return;
          }
        }

        if (e.key === 'Tab') {
          const focusables = Array.from(this.querySelectorAll('button:not([disabled])'));
          if (!focusables.length) return;
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      open({ src, alt = '', opener = null }) {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }

        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout);
          this.closeTimeout = null;
        }
        if (this.focusTimeout) {
          clearTimeout(this.focusTimeout);
          this.focusTimeout = null;
        }

        this.openedBy = opener;
        this.isOpen = true;
        this.isClosing = false;

        this.loadCount = (this.loadCount || 0) + 1;
        const currentLoadId = this.loadCount;

        const isNewImage = this.currentSrc !== src;
        this.currentSrc = src;

        if (this.image) {
          this.image.onload = null;
          this.image.onerror = null;

          if (isNewImage) {
            this.image.style.opacity = '0';
            this.classList.add('is-loading');
          }

          this.image.onload = () => {
            if (this.loadCount !== currentLoadId) return;
            this.image.style.opacity = '1';
            this.classList.remove('is-loading');
          };
          this.image.onerror = () => {
            if (this.loadCount !== currentLoadId) return;
            this.image.style.opacity = '1';
            this.classList.remove('is-loading');
          };

          this.image.src = src;
          this.image.alt = alt;

          if (this.image.complete && this.image.naturalWidth > 0) {
            this.image.style.opacity = '1';
            this.classList.remove('is-loading');
          }
        }

        this.scale = 1.0;
        this.posX = 0;
        this.posY = 0;
        this.updateTransform(false);
        this.canvas.classList.remove('is-zoomed', 'is-panning', 'is-grabbing');

        document.body.style.overflow = 'hidden';
        document.body.classList.add('overflow-hidden', 'brix-lightbox-open');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setAttribute('aria-hidden', 'false');
            this.classList.add('is-open');
          });
        });

        window.addEventListener('keydown', this.boundOnKeydown);

        this.focusTimeout = setTimeout(() => {
          if (!this.closeBtn) {
            this.closeBtn = this.querySelector('.brix-lightbox__close');
          }
          if (this.closeBtn) {
            this.closeBtn.focus();
          }
        }, 60);
      }

      close() {
        if (!this.isOpen || this.isClosing) return;
        this.isClosing = true;
        this.isOpen = false;

        this.loadCount = (this.loadCount || 0) + 1;
        if (this.image) {
          this.image.onload = null;
          this.image.onerror = null;
        }

        if (this.focusTimeout) {
          clearTimeout(this.focusTimeout);
          this.focusTimeout = null;
        }

        this.setAttribute('aria-hidden', 'true');
        this.classList.remove('is-open');
        document.body.style.overflow = '';
        document.body.classList.remove('overflow-hidden', 'brix-lightbox-open');

        window.removeEventListener('keydown', this.boundOnKeydown);

        if (this.openedBy && typeof this.openedBy.focus === 'function') {
          this.openedBy.focus();
        }

        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout);
        }

        this.closeTimeout = setTimeout(() => {
          this.isClosing = false;
          this.classList.remove('is-loading');
          this.scale = 1.0;
          this.posX = 0;
          this.posY = 0;
          this.updateTransform(false);
          this.canvas.classList.remove('is-zoomed', 'is-panning', 'is-grabbing');
          if (this.image) {
            this.image.style.opacity = '0';
            this.image.src = '';
            this.image.alt = '';
          }
          this.currentSrc = '';
          this.closeTimeout = null;
        }, 300);
      }

      setZoom(targetScale, animate = true) {
        const clamped = Math.min(this.maxScale, Math.max(this.minScale, targetScale));
        this.scale = Math.round(clamped * 100) / 100;

        if (this.scale <= 1.0) {
          this.posX = 0;
          this.posY = 0;
          this.canvas.classList.remove('is-zoomed');
        } else {
          this.canvas.classList.add('is-zoomed');
          this.clampPositions();
        }

        this.updateTransform(animate);
      }

      clampPositions() {
        if (this.scale <= 1.0 || !this.stage || !this.image) {
          this.posX = 0;
          this.posY = 0;
          return;
        }
        const stageRect = this.stage.getBoundingClientRect();
        const imgRect = this.image.getBoundingClientRect();
        const baseW = imgRect.width / this.scale;
        const baseH = imgRect.height / this.scale;
        const scaledW = baseW * this.scale;
        const scaledH = baseH * this.scale;

        const maxPanX = Math.max(0, (scaledW - stageRect.width) / 2 + 50);
        const maxPanY = Math.max(0, (scaledH - stageRect.height) / 2 + 50);

        this.posX = Math.min(maxPanX, Math.max(-maxPanX, this.posX));
        this.posY = Math.min(maxPanY, Math.max(-maxPanY, this.posY));
      }

      updateTransform(animate = true) {
        if (!this.canvas) return;
        if (!animate) {
          this.canvas.classList.add('is-panning');
        } else {
          this.canvas.classList.remove('is-panning');
        }
        this.canvas.style.transform = `translate(${Math.round(this.posX)}px, ${Math.round(this.posY)}px) scale(${this.scale})`;
      }
    }

    customElements.define('brix-image-lightbox', BrixImageLightbox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brix-apps-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const heroAnchor = document.querySelector('.brix-hero__btn--secondary[href^="#"]');
    if (heroAnchor) {
      heroAnchor.addEventListener('click', (e) => {
        const targetId = heroAnchor.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });
          if (history.pushState) {
            history.pushState(null, '', '#' + targetId);
          } else {
            window.location.hash = targetId;
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-studies-filter"] && !Shopify.designMode) return;
  try {
    
  class CaseStudiesFilterBar extends HTMLElement {
    connectedCallback() {
      this.pills = this.querySelectorAll('.case-studies-filter__pill');
      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => this.selectFilter(pill));
        pill.addEventListener('keydown', (event) => this.handleKeydown(event, pill));
      });

      requestAnimationFrame(() => this.initFilterFromUrl());
    }

    initFilterFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const urlFilter = urlParams.get('filter') || urlParams.get('category') || (window.location.hash ? window.location.hash.replace('#', '') : '');

      if (urlFilter) {
        const matchingPill = Array.from(this.pills).find(
          (pill) => pill.dataset.filterValue === urlFilter
        );
        if (matchingPill) {
          this.selectFilter(matchingPill);
        }
      }
    }

    selectFilter(activePill) {
      const filterValue = activePill.dataset.filterValue || '';

      this.pills.forEach((pill) => {
        const isActive = pill === activePill;
        pill.classList.toggle('case-studies-filter__pill--active', isActive);
        pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      document.dispatchEvent(
        new CustomEvent('case-studies:filter-change', {
          detail: { filterValue },
        })
      );
    }

    handleKeydown(event, currentPill) {
      const pills = Array.from(this.pills);
      const currentIndex = pills.indexOf(currentPill);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        nextIndex = (currentIndex + 1) % pills.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        nextIndex = (currentIndex - 1 + pills.length) % pills.length;
      } else if (event.key === 'Home') {
        event.preventDefault();
        nextIndex = 0;
      } else if (event.key === 'End') {
        event.preventDefault();
        nextIndex = pills.length - 1;
      } else {
        return;
      }

      pills[nextIndex].focus();
      this.selectFilter(pills[nextIndex]);
    }
  }

  if (!customElements.get('case-studies-filter-bar')) {
    customElements.define('case-studies-filter-bar', CaseStudiesFilterBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-studies-listing"] && !Shopify.designMode) return;
  try {
    
  class CaseStudiesListing extends HTMLElement {
    connectedCallback() {
      this.cards = document.querySelectorAll('.case-study-card');
      this.tierGroups = this.querySelectorAll('[data-tier-group]');
      this.activeFilter = '';

      document.addEventListener('case-studies:filter-change', (event) => {
        this.activeFilter = event.detail.filterValue || '';
        this.applyFilter();
      });
    }

    applyFilter() {
      this.cards.forEach((card) => {
        const categories = (card.dataset.filterCategories || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);

        let visible = true;

        if (this.activeFilter !== '') {
          visible = categories.includes(this.activeFilter);
        }

        card.classList.toggle('is-filtered-out', !visible);
        card.toggleAttribute('hidden', !visible);
      });

      this.tierGroups.forEach((group) => {
        const tier = group.dataset.tierGroup;
        const visibleCards = group.querySelectorAll(
          `.case-study-card[data-tier="${tier}"]:not(.is-filtered-out)`
        );
        group.hidden = visibleCards.length === 0;
      });
    }
  }

  if (!customElements.get('case-studies-listing')) {
    customElements.define('case-studies-listing', CaseStudiesListing);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  (function initMenuParentLinks() {
    document.querySelectorAll('.header__menu-parent-link').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });
  })();

  (function initBrainboxMobileDrawer() {
    const wrapper = document.querySelector('.header-wrapper--brainbox');
    if (!wrapper) return;

    const drawer = wrapper.querySelector('header-drawer');
    if (!drawer) return;

    const mainDetails = drawer.querySelector('#Details-menu-drawer-container');
    const summary = mainDetails?.querySelector('summary');
    if (!mainDetails || !summary) return;

    const closeDrawer = () => {
      if (!mainDetails.hasAttribute('open')) return;
      summary.click();
    };

    drawer.querySelector('.menu-drawer__header-close')?.addEventListener('click', (event) => {
      event.preventDefault();
      closeDrawer();
    });

    drawer.querySelectorAll('.menu-drawer__navigation a.menu-drawer__menu-item[href]').forEach((link) => {
      link.addEventListener('click', closeDrawer);
    });

    drawer.querySelector('.menu-drawer__cta-footer a[href]')?.addEventListener('click', closeDrawer);

    const accordionDuration = 280;

    const resetGroupedAccordions = () => {
      drawer.querySelectorAll('.menu-drawer__navigation details').forEach((details) => {
        const accordionSummary = details.querySelector('summary.menu-drawer__menu-item--accordion');
        const submenu = details.querySelector('.menu-drawer__submenu--grouped');
        if (!accordionSummary || !submenu) return;

        if (submenu.dataset.bbCloseTimeout) {
          window.clearTimeout(Number(submenu.dataset.bbCloseTimeout));
          delete submenu.dataset.bbCloseTimeout;
        }

        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        accordionSummary.setAttribute('aria-expanded', 'false');
        submenu.classList.remove('is-closing');
        submenu.style.gridTemplateRows = '';
        details.closest('.has-submenu')?.classList.remove('submenu-open');
      });
    };

    mainDetails.addEventListener('toggle', () => {
      if (!mainDetails.hasAttribute('open')) resetGroupedAccordions();
    });

    if (drawer.dataset.bbAccordionInit !== 'true') {
      drawer.dataset.bbAccordionInit = 'true';

      drawer.querySelectorAll('.menu-drawer__navigation details').forEach((details) => {
        const accordionSummary = details.querySelector('summary.menu-drawer__menu-item--accordion');
        const submenu = details.querySelector('.menu-drawer__submenu--grouped');
        if (!accordionSummary || !submenu) return;

        const parentMenu = details.closest('.has-submenu');
        const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const finishClose = () => {
          if (submenu.dataset.bbCloseTimeout) {
            window.clearTimeout(Number(submenu.dataset.bbCloseTimeout));
            delete submenu.dataset.bbCloseTimeout;
          }

          details.removeAttribute('open');
          submenu.classList.remove('is-closing');
          submenu.style.gridTemplateRows = '';
        };

        const closeAccordion = () => {
          accordionSummary.setAttribute('aria-expanded', 'false');
          details.classList.remove('menu-opening');
          parentMenu?.classList.remove('submenu-open');

          if (reducedMotion()) {
            finishClose();
            return;
          }

          submenu.classList.add('is-closing');
          submenu.dataset.bbCloseTimeout = String(
            window.setTimeout(finishClose, accordionDuration)
          );
        };

        const openAccordion = () => {
          if (submenu.dataset.bbCloseTimeout) {
            window.clearTimeout(Number(submenu.dataset.bbCloseTimeout));
            delete submenu.dataset.bbCloseTimeout;
          }

          details.setAttribute('open', '');
          accordionSummary.setAttribute('aria-expanded', 'true');
          details.classList.add('menu-opening');
          parentMenu?.classList.add('submenu-open');
          submenu.classList.remove('is-closing');

          if (reducedMotion()) {
            submenu.style.gridTemplateRows = '';
            return;
          }

          submenu.style.gridTemplateRows = '0fr';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              submenu.style.gridTemplateRows = '';
            });
          });
        };

        accordionSummary.addEventListener(
          'click',
          (event) => {
            const parentLink = accordionSummary.querySelector('.header__menu-parent-link');
            if (parentLink && (event.target === parentLink || parentLink.contains(event.target))) {
              return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            if (details.hasAttribute('open')) {
              closeAccordion();
            } else {
              openAccordion();
            }
          },
          true
        );
      });

      drawer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openAccordionDetails = drawer.querySelector(
          '.menu-drawer__navigation details[open]:has(.menu-drawer__submenu--grouped)'
        );
        if (!openAccordionDetails) return;

        const accordionSummary = openAccordionDetails.querySelector('summary.menu-drawer__menu-item--accordion');
        const submenu = openAccordionDetails.querySelector('.menu-drawer__submenu--grouped');
        if (!accordionSummary || !submenu) return;

        event.preventDefault();
        event.stopPropagation();

        accordionSummary.setAttribute('aria-expanded', 'false');
        openAccordionDetails.classList.remove('menu-opening');
        openAccordionDetails.closest('.has-submenu')?.classList.remove('submenu-open');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          openAccordionDetails.removeAttribute('open');
          submenu.classList.remove('is-closing');
          submenu.style.gridTemplateRows = '';
          return;
        }

        submenu.classList.add('is-closing');
        window.setTimeout(() => {
          openAccordionDetails.removeAttribute('open');
          submenu.classList.remove('is-closing');
          submenu.style.gridTemplateRows = '';
        }, accordionDuration);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // 1. Reading progress bar
    const progressEl = document.getElementById('bb-reading-progress');
    if (progressEl) {
      window.addEventListener('scroll', () => {
        const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (totalHeight > 0) {
          const progress = (window.scrollY / totalHeight) * 100;
          progressEl.style.width = `${Math.min(100, Math.max(0, progress))}%`;
        }
      }, { passive: true });
    }

    // 2. Dynamic Table of Contents Generation
    const articleBody = document.querySelector('.article-template__body');
    const stickyTocNav = document.querySelector('.article-template__toc-nav');
    const inlineTocList = document.querySelector('.article-template__toc-list');
    const tocWrappers = document.querySelectorAll('.article-template__toc-wrapper');

    // Reposition In-body CTA after H2 #3 or #4
    const inlineCta = document.querySelector('.inline-cta');
    if (inlineCta && articleBody) {
      const h2s = articleBody.querySelectorAll('h2');
      // For articles where brief specifies after H2 #3 (e.g. API 2026-10, Web Pixels), place after H2 #3; otherwise after H2 #4
      const isH2_3_Target = h2s.length === 6 || window.location.pathname.includes('shopify-web-pixels');
      const targetIndex = isH2_3_Target ? 3 : 4;
      if (h2s.length > targetIndex) {
        h2s[targetIndex].parentNode.insertBefore(inlineCta, h2s[targetIndex]);
      }
    }

    if (articleBody) {
      const headings = articleBody.querySelectorAll('h2');
      if (headings.length > 0) {
        headings.forEach((heading, index) => {
          if (!heading.id) {
            heading.id = heading.textContent
              .toLowerCase()
              .trim()
              .replace(/[^\w\s-]/g, '')
              .replace(/[\s_-]+/g, '-')
              .replace(/^-+|-+$/g, '') || `section-${index + 1}`;
          }

          const titleText = heading.textContent.trim();
          const num = String(index + 1).padStart(2, '0');

          if (stickyTocNav) {
            const a = document.createElement('a');
            a.href = `#${heading.id}`;
            a.className = 'article-template__toc-link';
            a.innerHTML = `<span class="article-template__toc-num">${num}</span><span>${titleText}</span>`;
            stickyTocNav.appendChild(a);
          }

          if (inlineTocList) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = `#${heading.id}`;
            a.textContent = titleText;
            li.appendChild(a);
            inlineTocList.appendChild(li);
          }
        });

        // 3. Scrollspy active highlight
        const tocLinks = document.querySelectorAll('.article-template__toc-link');
        if (tocLinks.length > 0) {
          const observerOptions = {
            root: null,
            rootMargin: '-100px 0px -66% 0px',
            threshold: 0
          };

          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const activeId = entry.target.id;
                tocLinks.forEach(link => {
                  if (link.getAttribute('href') === `#${activeId}`) {
                    link.classList.add('active');
                  } else {
                    link.classList.remove('active');
                  }
                });
              }
            });
          }, observerOptions);

          headings.forEach(heading => observer.observe(heading));
        }
      } else {
        tocWrappers.forEach(wrap => wrap.style.display = 'none');
      }
    }

    // 4. Code Block Syntax Highlighting (TOML & JS)
    function escapeHtml(str) {
      return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function highlightToml(block) {
      const lines = block.textContent.split('\n');
      let inMultilineString = false;
      let multilineQuote = '';

      const highlightedLines = lines.map(line => {
        if (inMultilineString) {
          const endIdx = line.indexOf(multilineQuote);
          if (endIdx !== -1) {
            inMultilineString = false;
            const strPart = line.slice(0, endIdx + 3);
            const rest = line.slice(endIdx + 3);
            return `<span class="token string">${escapeHtml(strPart)}</span>${escapeHtml(rest)}`;
          }
          return `<span class="token string">${escapeHtml(line)}</span>`;
        }

        const multiMatch = line.match(/^(\s*[A-Za-z0-9_.-]+\s*=\s*)("""|''')([\s\S]*)$/);
        if (multiMatch) {
          const prefix = multiMatch[1];
          multilineQuote = multiMatch[2];
          const rest = multiMatch[3];
          const keyMatch = prefix.match(/^(\s*)([A-Za-z0-9_.-]+)(\s*=\s*)$/);
          const prefixHtml = `${escapeHtml(keyMatch[1])}<span class="token key">${escapeHtml(keyMatch[2])}</span><span class="token punctuation">${escapeHtml(keyMatch[3])}</span>`;
          
          const endIdx = rest.indexOf(multilineQuote);
          if (endIdx !== -1) {
            const strPart = multilineQuote + rest.slice(0, endIdx + 3);
            const after = rest.slice(endIdx + 3);
            return `${prefixHtml}<span class="token string">${escapeHtml(strPart)}</span>${escapeHtml(after)}`;
          } else {
            inMultilineString = true;
            return `${prefixHtml}<span class="token string">${escapeHtml(multilineQuote + rest)}</span>`;
          }
        }

        const commentMatch = line.match(/^(\s*)(#.*)$/);
        if (commentMatch) {
          return `${escapeHtml(commentMatch[1])}<span class="token comment">${escapeHtml(commentMatch[2])}</span>`;
        }

        const sectionMatch = line.match(/^(\s*)(\[\[?)([A-Za-z0-9_.-]+)(\]?\])(\s*)(#.*)?$/);
        if (sectionMatch) {
          const indent = escapeHtml(sectionMatch[1]);
          const openBracket = escapeHtml(sectionMatch[2]);
          const secName = escapeHtml(sectionMatch[3]);
          const closeBracket = escapeHtml(sectionMatch[4]);
          const trailingSpace = escapeHtml(sectionMatch[5] || '');
          const comment = sectionMatch[6] ? `<span class="token comment">${escapeHtml(sectionMatch[6])}</span>` : '';
          return `${indent}<span class="token punctuation">${openBracket}</span><span class="token section">${secName}</span><span class="token punctuation">${closeBracket}</span>${trailingSpace}${comment}`;
        }

        const kvMatch = line.match(/^(\s*)([A-Za-z0-9_.-]+)(\s*=\s*)(.*)$/);
        if (kvMatch) {
          const indent = escapeHtml(kvMatch[1]);
          const key = escapeHtml(kvMatch[2]);
          const eq = escapeHtml(kvMatch[3]);
          let valRaw = kvMatch[4];

          let commentHtml = '';
          let inSingle = false;
          let inDouble = false;
          let foundIdx = -1;
          for (let i = 0; i < valRaw.length; i++) {
            const char = valRaw[i];
            if (char === '"' && !inSingle && (i === 0 || valRaw[i - 1] !== '\\')) inDouble = !inDouble;
            else if (char === "'" && !inDouble && (i === 0 || valRaw[i - 1] !== '\\')) inSingle = !inSingle;
            else if (char === '#' && !inSingle && !inDouble) {
              foundIdx = i;
              break;
            }
          }
          if (foundIdx !== -1) {
            commentHtml = `<span class="token comment">${escapeHtml(valRaw.slice(foundIdx))}</span>`;
            valRaw = valRaw.slice(0, foundIdx);
          }

          let valHtml = '';
          const valTrimmed = valRaw.trim();
          if ((valTrimmed.startsWith('"') && valTrimmed.endsWith('"')) || (valTrimmed.startsWith("'") && valTrimmed.endsWith("'"))) {
            valHtml = `<span class="token string">${escapeHtml(valRaw)}</span>`;
          } else if (valTrimmed === 'true' || valTrimmed === 'false') {
            const vIndent = valRaw.slice(0, valRaw.indexOf(valTrimmed));
            const vAfter = valRaw.slice(valRaw.indexOf(valTrimmed) + valTrimmed.length);
            valHtml = `${escapeHtml(vIndent)}<span class="token boolean">${valTrimmed}</span>${escapeHtml(vAfter)}`;
          } else if (/^\d+(\.\d+)?$/.test(valTrimmed)) {
            const vIndent = valRaw.slice(0, valRaw.indexOf(valTrimmed));
            const vAfter = valRaw.slice(valRaw.indexOf(valTrimmed) + valTrimmed.length);
            valHtml = `${escapeHtml(vIndent)}<span class="token number">${valTrimmed}</span>${escapeHtml(vAfter)}`;
          } else if (valTrimmed.startsWith('[') && valTrimmed.endsWith(']')) {
            valHtml = escapeHtml(valRaw)
              .replace(/(\[|\]|,)/g, '<span class="token punctuation">$1</span>')
              .replace(/(&quot;.*?&quot;|&#39;.*?&#39;)/g, '<span class="token string">$1</span>');
          } else {
            valHtml = escapeHtml(valRaw);
          }

          return `${indent}<span class="token key">${key}</span><span class="token punctuation">${eq}</span>${valHtml}${commentHtml}`;
        }

        return escapeHtml(line);
      });

      block.innerHTML = highlightedLines.join('\n');
    }

    function highlightJs(block) {
      const code = block.textContent;
      const tokenRegex = /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`)|(\b(?:import|export|from|as|default|const|let|var|function|return|if|else|for|while|await|async|new|try|catch|finally|throw|class|extends)\b)|(\b(?:true|false|null|undefined)\b)|(\b\d+(?:\.\d+)?\b)|(\b(?:JSON|window|document|console|fetch|Shopify)\b)|(\b[a-zA-Z_$][a-zA-Z0-9_$]*(?=\s*\())|([{}()[\].,;:?]|=>|===|==|=|!==|!=|&&|\|\||\+|\-|\*|\/)/g;

      let lastIndex = 0;
      let html = '';
      let match;

      while ((match = tokenRegex.exec(code)) !== null) {
        if (match.index > lastIndex) {
          html += escapeHtml(code.slice(lastIndex, match.index));
        }
        const [full, comment, string, keyword, boolean, number, builtin, func, punct] = match;
        if (comment) {
          html += `<span class="token comment">${escapeHtml(comment)}</span>`;
        } else if (string) {
          html += `<span class="token string">${escapeHtml(string)}</span>`;
        } else if (keyword) {
          html += `<span class="token keyword">${escapeHtml(keyword)}</span>`;
        } else if (boolean) {
          html += `<span class="token boolean">${escapeHtml(boolean)}</span>`;
        } else if (number) {
          html += `<span class="token number">${escapeHtml(number)}</span>`;
        } else if (builtin) {
          html += `<span class="token class-name">${escapeHtml(builtin)}</span>`;
        } else if (func) {
          html += `<span class="token function">${escapeHtml(func)}</span>`;
        } else if (punct) {
          html += `<span class="token punctuation">${escapeHtml(punct)}</span>`;
        }
        lastIndex = match.index + full.length;
      }
      if (lastIndex < code.length) {
        html += escapeHtml(code.slice(lastIndex));
      }
      block.innerHTML = html;
    }

    function highlightLiquid(block) {
      const code = block.textContent;
      const tokenRegex = /(\x7b%-?[\s\S]*?-?%\x7d|\x7b\x7b-?[\s\S]*?-?\x7d\x7d)|("(?:\\.|[^"\\])*")(?=\s*:)|("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*')|(<\/?[a-zA-Z0-9_-]+|\/?>)|(\b(?:true|false|null)\b)|(\b\d+(?:\.\d+)?\b)|(\b[a-zA-Z0-9_-]+(?=\s*:))|([{}()[\].,;:?|=])/g;

      let lastIndex = 0;
      let html = '';
      let match;

      while ((match = tokenRegex.exec(code)) !== null) {
        if (match.index > lastIndex) {
          html += escapeHtml(code.slice(lastIndex, match.index));
        }
        const [full, liquidTag, jsonKey, string, htmlTag, boolean, number, key, punct] = match;
        if (liquidTag) {
          let tagHtml = escapeHtml(liquidTag)
            .replace(/(&quot;(?:\\.|[^&])*?&quot;|&#39;(?:\\.|[^&])*?&#39;)/g, '<span class="token string">$1</span>')
            .replace(/\b(assign|schema|endschema|if|elsif|else|endif|for|endfor|case|when|endcase|capture|endcapture|comment|endcomment|render|include|paginate|endpaginate)\b/g, '<span class="token keyword">$1</span>')
            .replace(/\b(block|settings|product|collection|template|section)\b/g, '<span class="token variable">$1</span>');
          html += `<span class="token keyword-tag">${tagHtml}</span>`;
        } else if (jsonKey) {
          html += `<span class="token key">${escapeHtml(jsonKey)}</span>`;
        } else if (string) {
          html += `<span class="token string">${escapeHtml(string)}</span>`;
        } else if (htmlTag) {
          html += `<span class="token function">${escapeHtml(htmlTag)}</span>`;
        } else if (boolean) {
          html += `<span class="token boolean">${escapeHtml(boolean)}</span>`;
        } else if (number) {
          html += `<span class="token number">${escapeHtml(number)}</span>`;
        } else if (key) {
          html += `<span class="token key">${escapeHtml(key)}</span>`;
        } else if (punct) {
          html += `<span class="token punctuation">${escapeHtml(punct)}</span>`;
        }
        lastIndex = match.index + full.length;
      }
      if (lastIndex < code.length) {
        html += escapeHtml(code.slice(lastIndex));
      }
      block.innerHTML = html;
    }

    function highlightText(block) {
      const lines = block.textContent.split('\n');
      const highlighted = lines.map(line => {
        const commentMatch = line.match(/^(\s*)(#.*)$/);
        if (commentMatch) {
          return `${escapeHtml(commentMatch[1])}<span class="token comment">${escapeHtml(commentMatch[2])}</span>`;
        }
        return escapeHtml(line);
      });
      block.innerHTML = highlighted.join('\n');
    }

    const codeBlocks = document.querySelectorAll('.article-body pre code, .article-template__body pre code');
    codeBlocks.forEach(block => {
      const classList = Array.from(block.classList);
      const isToml = classList.some(c => c === 'language-toml');
      const isJs = classList.some(c => c === 'language-javascript' || c === 'language-js');
      const isLiquid = classList.some(c => c === 'language-liquid');
      const isText = classList.some(c => c === 'language-text');
      if (isToml) {
        highlightToml(block);
      } else if (isJs) {
        highlightJs(block);
      } else if (isLiquid) {
        highlightLiquid(block);
      } else if (isText) {
        highlightText(block);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-faq"] && !Shopify.designMode) return;
  try {
    
  class ServicesFaqSection extends HTMLElement {
    connectedCallback() {
      this.details = Array.from(this.querySelectorAll('.services-faq__details'));
      this.showMoreButton = this.querySelector('[data-services-faq-show-more]');
      this.hiddenItems = Array.from(this.querySelectorAll('[data-services-faq-hidden]'));
      this.showMoreLabel = this.dataset.showMoreLabel || 'Show more questions';
      this.showLessLabel = this.dataset.showLessLabel || 'Show fewer questions';
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.details.forEach((detail) => {
        const summary = detail.querySelector('.services-faq__question');

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleDetail(detail);
        });

        if (detail.open && !detail.classList.contains('is-open')) {
          detail.classList.add('is-open');
        }
      });

      if (!this.showMoreButton || this.hiddenItems.length === 0) return;

      this.showMoreButton.addEventListener('click', () => {
        const isExpanded = this.showMoreButton.getAttribute('aria-expanded') === 'true';
        this.toggleShowMore(!isExpanded);
      });
    }

    toggleShowMore(nextExpanded) {
      this.showMoreButton.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      this.showMoreButton.textContent = nextExpanded ? this.showLessLabel : this.showMoreLabel;

      if (this.prefersReducedMotion) {
        this.hiddenItems.forEach((item) => {
          item.hidden = !nextExpanded;
          if (!nextExpanded) {
            const detail = item.querySelector('.services-faq__details');
            if (detail && detail.classList.contains('is-open')) {
              this.closeDetail(detail);
            }
          }
        });
        return;
      }

      if (nextExpanded) {
        this.hiddenItems.forEach((item) => {
          item.hidden = false;
          item.style.overflow = 'hidden';
          item.style.height = '0px';
          item.style.opacity = '0';
          item.style.transition = 'height 0.35s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.3s ease';

          const targetHeight = item.scrollHeight;

          requestAnimationFrame(() => {
            item.style.height = `${targetHeight}px`;
            item.style.opacity = '1';
          });

          const onEnd = (event) => {
            if (event.target !== item || event.propertyName !== 'height') return;
            item.removeEventListener('transitionend', onEnd);
            item.style.overflow = '';
            item.style.height = '';
            item.style.opacity = '';
            item.style.transition = '';
          };
          item.addEventListener('transitionend', onEnd);
        });
      } else {
        this.hiddenItems.forEach((item) => {
          const detail = item.querySelector('.services-faq__details');
          if (detail && detail.classList.contains('is-open')) {
            this.closeDetail(detail);
          }

          const startHeight = item.scrollHeight;
          item.style.overflow = 'hidden';
          item.style.height = `${startHeight}px`;
          item.style.opacity = '1';
          item.style.transition = 'height 0.35s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.3s ease';

          item.getBoundingClientRect();

          requestAnimationFrame(() => {
            item.style.height = '0px';
            item.style.opacity = '0';
          });

          const onEnd = (event) => {
            if (event.target !== item || event.propertyName !== 'height') return;
            item.removeEventListener('transitionend', onEnd);
            item.hidden = true;
            item.style.overflow = '';
            item.style.height = '';
            item.style.opacity = '';
            item.style.transition = '';
          };
          item.addEventListener('transitionend', onEnd);
        });
      }
    }

    toggleDetail(detail) {
      const isOpen = detail.classList.contains('is-open');

      if (isOpen) {
        this.closeDetail(detail);
        return;
      }

      this.details.forEach((other) => {
        if (other !== detail && other.classList.contains('is-open')) {
          this.closeDetail(other);
        }
      });

      this.openDetail(detail);
    }

    openDetail(detail) {
      const panel = detail.querySelector('.services-faq__answer-panel');
      if (!panel) return;

      if (panel._currentAnimation) {
        panel._currentAnimation.cancel();
        panel._currentAnimation = null;
      }

      detail.classList.add('is-open');
      detail.open = true;

      if (this.prefersReducedMotion) return;

      panel.style.overflow = 'hidden';
      const startHeight = panel._isClosing ? panel.offsetHeight : 0;
      panel._isClosing = false;
      const endHeight = panel.scrollHeight;

      const anim = panel.animate(
        [
          { height: `${startHeight}px`, opacity: 0 },
          { height: `${endHeight}px`, opacity: 1 }
        ],
        {
          duration: 450,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
        }
      );

      panel._currentAnimation = anim;

      anim.onfinish = () => {
        panel.style.height = '';
        panel.style.overflow = '';
        panel._currentAnimation = null;
      };
    }

    closeDetail(detail) {
      const panel = detail.querySelector('.services-faq__answer-panel');
      if (!panel) return;

      if (panel._currentAnimation) {
        panel._currentAnimation.cancel();
        panel._currentAnimation = null;
      }

      detail.classList.remove('is-open');

      if (this.prefersReducedMotion) {
        detail.open = false;
        return;
      }

      panel._isClosing = true;
      panel.style.overflow = 'hidden';
      const startHeight = panel.offsetHeight;

      const anim = panel.animate(
        [
          { height: `${startHeight}px`, opacity: 1 },
          { height: '0px', opacity: 0 }
        ],
        {
          duration: 360,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
        }
      );

      panel._currentAnimation = anim;

      anim.onfinish = () => {
        detail.open = false;
        panel.style.height = '';
        panel.style.overflow = '';
        panel._currentAnimation = null;
        panel._isClosing = false;
      };
    }

    abortPanelTransition(panel) {
      if (!panel || !panel._currentAnimation) return;
      panel._currentAnimation.cancel();
      panel._currentAnimation = null;
    }
  }

  if (!customElements.get('services-faq-section')) {
    customElements.define('services-faq-section', ServicesFaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('services-hero')) {
    customElements.define(
      'services-hero',
      class ServicesHero extends HTMLElement {
        connectedCallback() {
          const secondaryButton = this.querySelector('.services-hero__button--secondary');
          if (!secondaryButton) return;

          secondaryButton.addEventListener('click', (event) => {
            const href = secondaryButton.getAttribute('href');
            if (!href || !href.startsWith('#')) return;

            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);
            if (!targetElement) return;

            event.preventDefault();

            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            targetElement.scrollIntoView({
              behavior: prefersReducedMotion ? 'auto' : 'smooth',
              block: 'start'
            });

            if (history.pushState) {
              history.pushState(null, '', href);
            } else {
              window.location.hash = href;
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["white-label-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('white-label-hero')) {
    customElements.define(
      'white-label-hero',
      class WhiteLabelHero extends HTMLElement {
        connectedCallback() {
          const secondaryButton = this.querySelector('.white-label-hero__button--secondary');
          if (!secondaryButton) return;

          secondaryButton.addEventListener('click', (event) => {
            const href = secondaryButton.getAttribute('href');
            if (!href || !href.startsWith('#')) return;

            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);
            if (!targetElement) return;

            event.preventDefault();

            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            targetElement.scrollIntoView({
              behavior: prefersReducedMotion ? 'auto' : 'smooth',
              block: 'start'
            });

            if (history.pushState) {
              history.pushState(null, '', href);
            } else {
              window.location.hash = href;
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
